import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { AppActionTypes } from '../actions/app.actions';

@Injectable()
export class AppEffects {
  constructor(private actions$: Actions) {}
}
